import React, { useState } from "react";
import { amenities } from "../mock";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Amenities = () => {
  const [idx, setIdx] = useState(0);
  const slides = amenities.slides;
  const prev = () => setIdx((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setIdx((i) => (i + 1) % slides.length);

  return (
    <section id="amenities-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${amenities.bg})`, backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className="absolute inset-0 bg-[#2a3d5c]/85" />
      <div className="relative max-w-[1320px] mx-auto px-5 lg:px-8">
        <div className="section-head">
          <p className="eyebrow" style={{ color: "#d68767" }}>Amenities</p>
          <div className="divider-leaf my-3" />
          <h2 className="h-title" style={{ color: "#f4ede2" }}>Thoughtful Spaces for a Balanced Life</h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3 relative">
            <div className="relative rounded-[22px] overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.35)]">
              <img src={slides[idx].image} alt={slides[idx].title} className="w-full h-[380px] md:h-[520px] object-cover transition-all duration-500" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#2a3d5c]/95 via-[#2a3d5c]/50 to-transparent p-6">
                <p className="font-display-e text-[11px] tracking-[.24em] text-[#d68767]">{slides[idx].tag}</p>
                <h3 className="h-title text-[26px] md:text-[34px]" style={{ color: "#f8f2e8" }}>{slides[idx].title}</h3>
              </div>
              <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/85 hover:bg-white text-[#2a3d5c] flex items-center justify-center transition"><ChevronLeft /></button>
              <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/85 hover:bg-white text-[#2a3d5c] flex items-center justify-center transition"><ChevronRight /></button>
            </div>
            <div className="flex justify-center gap-2 mt-4">
              {slides.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-[#d68767]" : "w-3 bg-white/40"}`} />
              ))}
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 gap-3">
            {amenities.list.map((a) => (
              <div key={a.label} className="flex items-center gap-3 bg-white/10 border border-white/15 hover:border-[#d68767]/60 rounded-xl p-3 transition">
                <div className="w-10 h-10 shrink-0 rounded-full bg-[#d68767]/15 flex items-center justify-center">
                  <img src={a.icon} alt="" className="w-5 h-5" style={{ filter: "brightness(0) invert(1)" }} />
                </div>
                <p className="text-[13px] font-medium" style={{ color: "#f8f2e8" }}>{a.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Amenities;
